import axios, { AxiosInstance, AxiosResponse } from "axios";
import config from "../config/appConfig";
import { getCookie, setCookie } from "../utils/cookies/cookieUtils";

const axiosInstance: AxiosInstance = axios.create({
  baseURL: config.apiBaseUrl,
});

// Function to refresh access token
async function refreshtoken() {
  const response = await axiosInstance.post("/user/refresh-token", {
    refreshToken: getCookie("refreshToken"),
  });
  const { token } = response.data;
  setCookie("token", token);
  return token;
}

// Request interceptor
axiosInstance.interceptors.request.use(
  async (config: any) => {
    const token = getCookie("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response: AxiosResponse) => response,
  async (error) => {
    const originalRequest = error.config;
    if (
      error.code == "ERR_NETWORK" &&
      window.location.pathname !== "/network-error"
    ) {
      window.location.href = "/network-error";
    }
    if (error.response.status === 498) {
      const token = getCookie("token");
      if (token) {
        const newtoken = await refreshtoken();
        originalRequest.headers["Authorization"] = `Bearer ${newtoken}`;
        return axiosInstance(originalRequest);
      } else {
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
